import axiosIns from '@axios'
import axios from 'axios'
import { User } from '@/models/user'

export interface CreateUserApiDTO {
  uuid: string
  email: string
  firstName: string
  lastName?: string
  country?: string
  describeAs?: string
  phoneNumber?: string | null
  signupSource?: string | null
  affiliateToken?: string | null
  noOfSites: number
}

export interface CreateUserForSecureCheckout {
  firstName: string
  lastName: string
  email: string
  password: string
  cardToken: string
  address: string
  address2: string
  city: string
  country: string
  zipCode: string
  state: string
  domain: string
  datacenter: string
  priceId: string
  addonsPriceIds?: string[]
  scoUUID: string
}

export interface CreateUserForStripeCheckout {
  email: string
  password: string
  bt_check: string
  previously_owned_sites_count: number
  signup_source: string
  biggest_challenge: string
}

export const getUser = async (uid?: string | undefined) => {
  const config = {}
  if (uid && uid !== 'undefined') {
    // @ts-ignore
    config.headers = {
      'customer-uuid': uid,
    }
  }
  const { data } = await axiosIns.get('/user', config)
  return data?.data
}

export const createUser = async (user: CreateUserApiDTO) => {
  console.log('Create user api call')
  const { data } = await axiosIns.post('/user/create', {
    ...user,
  })
  return data?.data
}

export const updateUser = async (
  user: Partial<User> & { update_reason?: string },
) => {
  const { data } = await axiosIns.put('/user', {
    uuid: user.uuid,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    country: user.country,
    describeAs: user.describeAs,
    phoneNumber: user.phoneNumber,
    update_reason: user.update_reason,
  })
  return data?.data
}

export const getSearchedUserByType = (query: string, type: string) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosIns.get(
        `admin/users/search/${query}/isAdmin/${type}`,
      )
      resolve(data?.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const getSearchedUserBySites = (query: string) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      query = query.replace('http://', '').replace('https://', '')
      if (query) {
        const { data } = await axiosIns.get(`domain/admin/search?name=${query}`)
        resolve(data?.data)
      } else {
        resolve([])
      }
    } catch (e) {
      reject(e)
    }
  })
}

export const getSearchedUserByEmailOrName = (query: string) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosIns.post(
        'admin/users/search/name-or-email/',
        {
          query: query,
        },
      )
      resolve(data?.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const getDashboardResourceStats = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosIns.get('site/user/dashboard/stats')
      resolve(data?.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const getUserProjectedBillingData = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosIns.get('site-invoice/upcoming')
      resolve(data?.data)
    } catch (e) {
      reject(e)
    }
  })
}

export const resetPassword = async (email: string) => {
  const { data } = await axiosIns.post('/user/reset-password', {
    email,
  })
  return data?.data
}

export const verifyUserByEmail = async (email: string | null) => {
  const { data } = await axiosIns.post('/user/verify', {
    email,
  })
  return data?.data
}

export const createUserForSecureCheckout = async (
  user: CreateUserForSecureCheckout,
) => {
  const { data } = await axiosIns.post('/user/signup/secure-checkout', {
    ...user,
  })
  return data?.data
}

export const createUserForStripeCheckout = async (
  user: CreateUserForStripeCheckout,
) => {
  const { data } = await axiosIns.post('/user/signup/stripe-checkout', {
    ...user,
  })
  return data?.data
}
export const userRecaptchaVerify = async (token: string) => {
  const { data } = await axiosIns.post('/user/recaptcha/verify', {
    token,
  })
  return data?.data
}

export const send2FACode = async () => {
  const { data } = await axiosIns.post('/user/send-2fa')
  return data?.data
}

export const verify2FACode = async (code: string) => {
  const { data } = await axiosIns.post('/user/verify-2fa', {
    code,
  })
  return data?.data
}

export const getSetupSession = async () => {
  const { data } = await axiosIns.get('/user/get-setup-session')
  return data?.data
}
export const logout = async () => {
  const { data } = await axiosIns.put('/user/logout')
  return data?.data
}

export const getCurrentIp = async (): Promise<string | undefined> => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json')
    const ipAddress = response.data.ip
    return ipAddress
  } catch (error) {
    console.log('Error fetching IP address:', error)
  }
}

export const verifyCheckoutCompleted = async (stripeCustomerId: string) => {
  try {
    await axiosIns.put(`/user/verify-checkout-completed/${stripeCustomerId}`)
  } catch (e) {
    console.log(e)
  }
}
